import { apiService } from '../_services'

export const roleService = {
  getRoleList
}
function getRoleList(){
    return apiService.fetchAuthGet('role')
      .then(response => {
        console.log(response)
        return response.data
      })
      .catch(error => {
        return error
      })
  }